const customCSSPropertiesMap: Record<string, string> = {
  breadcrumbsGap: '--awsui-breadcrumbs-gap-y98gph',
  contentGapLeft: '--awsui-content-gap-left-y98gph',
  contentGapRight: '--awsui-content-gap-right-y98gph',
  contentHeight: '--awsui-content-height-y98gph',
  containerFirstGap: '--awsui-container-first-gap-y98gph',
  containerFirstOverlapExtension: '--awsui-container-first-overlap-extension-y98gph',
  defaultMaxContentWidth: '--awsui-default-max-content-width-y98gph',
  defaultMinContentWidth: '--awsui-default-min-content-width-y98gph',
  drawerSize: '--awsui-drawer-size-y98gph',
  footerHeight: '--awsui-footer-height-y98gph',
  headerGap: '--awsui-header-gap-y98gph',
  headerHeight: '--awsui-header-height-y98gph',
  layoutWidth: '--awsui-layout-width-y98gph',
  mainGap: '--awsui-main-gap-y98gph',
  mainOffsetLeft: '--awsui-main-offset-left-y98gph',
  mainTemplateRows: '--awsui-main-template-rows-y98gph',
  maxContentWidth: '--awsui-max-content-width-y98gph',
  minContentWidth: '--awsui-min-content-width-y98gph',
  mobileBarHeight: '--awsui-mobile-bar-height-y98gph',
  notificationsGap: '--awsui-notifications-gap-y98gph',
  notificationsHeight: '--awsui-notifications-height-y98gph',
  offsetTop: '--awsui-offset-top-y98gph',
  offsetTopWithNotifications: '--awsui-offset-top-with-notifications-y98gph',
  overlapHeight: '--awsui-overlap-height-y98gph',
  navigationWidth: '--awsui-navigation-width-y98gph',
  splitPanelReportedHeaderSize: '--awsui-split-panel-reported-header-size-y98gph',
  splitPanelReportedSize: '--awsui-split-panel-reported-size-y98gph',
  splitPanelHeight: '--awsui-split-panel-height-y98gph',
  splitPanelMinWidth: '--awsui-split-panel-min-width-y98gph',
  splitPanelMaxWidth: '--awsui-split-panel-max-width-y98gph',
  toolsMaxWidth: '--awsui-tools-max-width-y98gph',
  toolsWidth: '--awsui-tools-width-y98gph',
  toolsAnimationStartingOpacity: '--awsui-tools-animation-starting-opacity-y98gph',
  contentScrollMargin: '--awsui-content-scroll-margin-y98gph',
  flashbarStackDepth: '--awsui-flashbar-stack-depth-y98gph',
  flashbarStackIndex: '--awsui-flashbar-stack-index-y98gph',
  flashbarStickyBottomMargin: '--awsui-flashbar-sticky-bottom-margin-y98gph',
  stackedNotificationsBottomMargin: '--awsui-stacked-notifications-bottom-margin-y98gph',
  stackedNotificationsDefaultBottomMargin: '--awsui-stacked-notifications-default-bottom-margin-y98gph',
  dropdownDefaultMaxWidth: '--awsui-dropdown-default-max-width-y98gph',
};
export default customCSSPropertiesMap;
